<template>
  <div :class="['component-icons-section', (isCurrent ? 'active' : '') ]">
    <div class="icons-container">
      <div class="icons">
        <div class="icon" v-for="(icon, key) in data.icons" @mouseenter="updateHoverState(key)" @mouseleave="updateHoverState(false)" :style="getIcon(key)" @click="setCurrent(key)">
          <img v-if="icon.icon_mini" :src="icon.icon_mini">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'title',
    'data',
    'isCurrent',
    'index',
    'isDisActive'
  ],

  data () {
    return {
      key: null,
      hover: null,
      cache: null
    }
  },

  mounted () {
    if (this.isCurrent) {
      this.setPage(0)
    }
  },

  methods: {
    setCurrent (key) {
      if (this.isDisActive) {
        return
      }
      if (this.isCurrent) {
        this.setPage(key)
      } else {
        this.$emit('setCurrent', this.index)
        this.cache = key
      }
    },

    setCacheMin () {
      this.cache = 0
    },

    setCacheMax () {
      this.cache = this.data.icons.length - 1
    },

    setPage (key) {
      this.key = key
      this.$emit('setContent', {
        html: this.data.icons[this.key].body,
        image: this.data.icons[this.key].image,
        background: null,
        color: this.data.icons[this.key].color,
        link: this.data.icons[this.key].link
      })
    },

    getIcon(key) {
      return {
        backgroundColor: (this.key === key || this.hover === key) ? this.data.icons[key].color : this.data.icons[key].icon_color
      }
    },

    updateHoverState(key) {
      this.hover = key
    },

    next() {
      if (this.data.icons.length !== (this.key + 1)) {
        let key = this.key == null ? 0 : (this.key + 1)
        this.setCurrent(key)
        return true
      }

      return false
    },

    prev() {
      if (this.key !== 0) {
        this.setCurrent(this.key - 1)
        return true
      }

      return false
    }
  },

  watch: {
    isCurrent (val) {
      this.isCurrent = val
        //    let dir = this.isCurrent > val ? 'next' : 'prev'
      if (this.isCurrent) {
        this.setPage(this.cache ? this.cache : 0)
      } else {
        this.key = null
      }
    }
  }
}
</script>

<style lang="scss">
.promo {
  .sections {
    .component-icons-section {
      height: 100%;
      .icons-container {
        display: flex;
        justify-content: center;
        padding: 80px 0px;
      }
      .icons {
         * {
         font-family: 'Montserrat', sans-serif;
       }
        display: flex;
        align-content: flex-start;
        flex-wrap: wrap;
        width: 95%;
        .icon {
          cursor: pointer;
          width: 79px;
          height: 79px;
          margin: 5px;
          padding: 2px;
          background-size: cover;
          background-position: center;
          transition: all .5s ease;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>